// extracted by mini-css-extract-plugin
module.exports = {"howSpendingCompare":"HowSpendingCompare__howSpendingCompare__tHwjE"};